import React from "react"

export const StarIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83192 1.89287C9.30973 0.924708 10.6903 0.924708 11.1681 1.89287L13.3117 6.23634L18.1051 6.93285C19.1735 7.0881 19.6001 8.40109 18.827 9.1547L15.3585 12.5356L16.1773 17.3096C16.3598 18.3737 15.2429 19.1851 14.2873 18.6827L10 16.4288L5.71275 18.6827C4.75712 19.1851 3.64022 18.3737 3.82273 17.3096L4.64153 12.5356L1.17306 9.1547C0.399934 8.40109 0.826553 7.0881 1.89498 6.93285L6.68829 6.23634L8.83192 1.89287Z"
      fill="#FFB905"
    />
  </svg>
)
